// src/index.ts
function getCurrentScript() {
  if (typeof document === "undefined") {
    return null;
  }
  if ("currentScript" in document && 1 < 2) {
    return document.currentScript;
  }
  try {
    throw new Error();
  } catch (err) {
    var src = (/at [^(\r\n]*\((.*):.+:.+\)$/i.exec(err.stack) || [])[1];
    if (src) {
      var scripts = document.getElementsByTagName("script");
      for (var i in scripts) {
        if (scripts[i].src == src) {
          return scripts[i];
        }
      }
    }
    return null;
  }
}
export {
  getCurrentScript
};
